


















import { Component, Vue, Prop } from 'vue-property-decorator'
import { TranslateResult } from 'vue-i18n'

@Component<AddDialog>({})
export default class AddDialog extends Vue {
  @Prop()
  button!: string | TranslateResult
  @Prop({ default: false, type: Boolean })
  icon!: boolean
  @Prop({ default: false, type: Boolean })
  password!: boolean
  @Prop()
  title?: string | TranslateResult
  @Prop()
  text!: string | TranslateResult
  @Prop()
  confirm!: string | TranslateResult

  dialog = false

  name = ''

  get hasSlots() {
    return Boolean(Object.values(this.$slots).length !== 0)
  }
  add(event: Event) {
    event.preventDefault()
    this.dialog = false
    this.$emit('add', this.name)
    this.name = ''
  }

  cancel() {
    this.dialog = false
    this.$emit('canceld')
  }
}
